import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Announcement } from './announcement.model';
import announcementService from './announcement.service';

// namespace
export const ANNOUNCEMENT_STORE_NAMESPACE = 'announcementStore';

// state
interface AnnouncementState {
  announcements: Announcement[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: AnnouncementState = {
  announcements: [],
  status: 'init',
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  FIND: 'find',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<AnnouncementState> = {
  [mutationConstant.FETCH]: (state: AnnouncementState, announcements: Announcement[]) => {
    state.announcements = announcements;
  },
  [mutationConstant.FIND]: (state: AnnouncementState, announcement: Announcement) => {
    if (state.announcements.some(m => m.id === announcement.id)) {
      const index = state.announcements.findIndex(m => m.id === announcement.id);
      state.announcements[index] = announcement;
    } else {
      state.announcements.push(announcement);
    }
  },
  [mutationConstant.PENDING]: (state: AnnouncementState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: AnnouncementState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: AnnouncementState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
  FIND: 'find',
};

const action: ActionTree<AnnouncementState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<AnnouncementState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      announcementService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
  [actionConstant.FIND](context: ActionContext<AnnouncementState, RootState>, id: number) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      announcementService.Find(id)
        .then((response) => {
          context.commit(mutationConstant.FIND, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<AnnouncementState, RootState> = {
  [getterConstant.ALL]: (state: AnnouncementState) => state.announcements,
  [getterConstant.BY_ID]: (state: AnnouncementState) => (id: number) => state.announcements.find(m => m.id === id),
  [getterConstant.STATUS]: (state: AnnouncementState) => state.status,
};

// module
const module: Module<AnnouncementState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const AnnouncementGetter = {
  ALL: `${ANNOUNCEMENT_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${ANNOUNCEMENT_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${ANNOUNCEMENT_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const AnnouncementAction = {
  FETCH: `${ANNOUNCEMENT_STORE_NAMESPACE}/${actionConstant.FETCH}`,
  FIND: `${ANNOUNCEMENT_STORE_NAMESPACE}/${actionConstant.FIND}`,
};

export default module;
